<ui-dialog
    [open]="isTemplateModalOpen"
    (closing)="resetTemplateId()"
    header="{{ 'forms.applicant-tracker.components.funnel-message-templates.confirmOverride' | appTranslate }}"
>
    <p>
        {{
            'forms.applicant-tracker.components.funnel-message-templates.areYouSureYouWantToUseThisTemplateYourCurrentMessageWillBeDiscarded'
                | appTranslate
        }}
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="resetTemplateId()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="danger" (click)="onTemplateIdChange()">{{
            'forms.applicant-tracker.components.funnel-message-templates.override' | appTranslate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>{{
                'forms.applicant-tracker.components.funnel-message-templates.from' | appTranslate
            }}</mat-label>
            <mat-select name="replyTo" #replyTo="ngModel" [(ngModel)]="bulkApplicantMessage.replyTo">
                <mat-option [value]="auth.account.email">{{ auth.account.email }}</mat-option>
                <mat-option value="no-reply@hire.humi.ca">no-reply&#64;hire.humi.ca </mat-option>
            </mat-select>
            <mat-error *ngIf="replyTo.invalid">{{ replyTo.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>{{
                'forms.applicant-tracker.components.funnel-message-templates.jobPosting' | appTranslate
            }}</mat-label>
            <mat-select
                [disabled]="route.snapshot.params?.jobPostingId"
                required
                name="jobPostingId"
                [(ngModel)]="jobPostingId"
                (selectionChange)="onJobPostingChange()"
            >
                <mat-option *ngFor="let jobPosting of jobPostings" [value]="jobPosting.id">{{
                    jobPosting.title
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>{{
                'forms.applicant-tracker.components.funnel-message-templates.template' | appTranslate
            }}</mat-label>
            <mat-select
                name="templateId"
                [ngModel]="templateId"
                (ngModelChange)="setPreviousTemplateId($event)"
                (selectionChange)="canOverride()"
            >
                <mat-option value="free-form">{{
                    'forms.applicant-tracker.components.funnel-message-templates.freeForm' | appTranslate
                }}</mat-option>
                <mat-option *ngFor="let template of applicantMessageTemplates" [value]="template.id">{{
                    template.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label appRemoveAriaOwns>{{
                'forms.applicant-tracker.components.funnel-message-templates.funnelStage' | appTranslate
            }}</mat-label>
            <mat-select required name="jobFunnelId" #jobFunnelSelect [(ngModel)]="bulkApplicantMessage.atsJobFunnelId">
                <mat-option *ngFor="let jobFunnel of selectedJobPosting?.jobFunnels" [value]="jobFunnel.id">{{
                    jobFunnel.funnelStep | appTranslateOptions: jobFunnelNameDisplayOptions
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-12 small-columns-12">
            <mat-label>{{
                'forms.applicant-tracker.components.funnel-message-templates.subject' | appTranslate
            }}</mat-label>
            <input
                type="text"
                required
                name="subject"
                [(ngModel)]="bulkApplicantMessage.subject"
                #subject="ngModel"
                matInput
            />
            <mat-error *ngIf="subject.invalid">{{
                'forms.applicant-tracker.components.funnel-message-templates.pleaseProvideAValidSubject' | appTranslate
            }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{
                'forms.applicant-tracker.components.funnel-message-templates.body' | appTranslate
            }}</mat-label>
            <ui-rich-text
                name="body"
                required
                #body="ngModel"
                [(ngModel)]="bulkApplicantMessage.body"
                [stripNewlines]="true"
            ></ui-rich-text>
        </mat-form-field>
    </div>
</form>
